import { GlBadge, GlTooltipDirective } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'ProtectedBadge',
    components: {
        GlBadge
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        tooltipText: {
            type: String,
            required: false,
            default: ''
        }
    }
};
